import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { useCamera } from "@common/hooks/useCamera"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { clearLastPhoto, clearPhotos } from "@data/redux/actions/camera"
import { activitiesService } from "@data/services/activitiesService"
import * as ImagePicker from "expo-image-picker"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Dimensions, FlatList, Vibration, View } from "react-native"
import { GestureHandlerRootView } from "react-native-gesture-handler"
import { TouchableRipple } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import ImageViewer from "../components/image/ImageViewer"
import { ModalM } from "../components/modal/ModalM"
import TextM from "../components/text/TextM"
import { theme } from "../theme/theme"
import { DimensionsContext, IS_WEB } from "../utils/mobileUtils"
import PhotoElement from "./PhotoElement"

export const pickImage = async (images, setImages) => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        quality: 1,
    })

    if (!result.canceled) {
        const imagesCopy = images?.map((x) => x) ?? []
        imagesCopy?.push({
            uri: result.assets[0].uri,
            width: result.assets[0].width,
            height: result.assets[0].height,
            selected: false,
        })
        setImages(imagesCopy)
    }
}

export const ImagesList = (props) => {
    const {
        listHeaderComponent = () => <></>,
        listFooterComponent = () => <></>,
        contentHeight,
        style,
        images,
        photoLongPress = () => {},
        withChrono = false,
        time,
        isSelecting = false,
        longPressDisabled = false,
        resendComponent,
        noResend = false,
        modalStyle = {},
        onDismissExtra = () => {},
        scrollToStart = false,
    } = props

    const dimensions = useContext(DimensionsContext)
    const flatListRef = useRef()
    // ** Image viewer
    const [openImageViewer, setOpenImageViewer] = useState(false)
    const [visibleIndex, setVisibleIndex] = useState(0)
    const hideImageViewer = () => {
        return setOpenImageViewer(false)
    }

    useEffect(() => {
        if (!scrollToStart) {
            flatListRef?.current?.scrollToEnd({ animated: false })
        }
    }, [])

    return (
        <>
            <FlatList
                data={images}
                ref={flatListRef}
                getItemLayout={(data, index) => ({
                    length: contentHeight,
                    offset: contentHeight * index,
                    index,
                })}
                horizontal
                style={{
                    width: dimensions?.width,
                    alignSelf: "center",
                    ...style,
                }}
                contentContainerStyle={{
                    alignItems: "center",
                    justifyContent: "center",
                    height: contentHeight,
                }}
                ListHeaderComponent={listHeaderComponent}
                ListFooterComponent={listFooterComponent}
                keyExtractor={(item, index) => index.toString()}
                renderItem={(itemInfo) => {
                    return (
                        <PhotoElement
                            uri={itemInfo.item?.uri}
                            height={itemInfo.item?.height}
                            width={itemInfo.item?.width}
                            parentHeight={contentHeight}
                            isSelecting={isSelecting}
                            selected={itemInfo.item?.selected}
                            onLongPress={
                                photoLongPress
                                    ? () => photoLongPress(itemInfo.index)
                                    : () => {}
                            }
                            longPressDisabled={longPressDisabled}
                            onPress={() => {
                                setOpenImageViewer(true)
                                setVisibleIndex(itemInfo.index)
                            }}
                            showResend={!itemInfo.item?.id && !noResend}
                            resendComponent={resendComponent}
                        />
                    )
                }}
            />

            <ImageViewerModal
                visible={openImageViewer}
                onDismiss={() => {
                    hideImageViewer()
                    onDismissExtra()
                }}
                imageIndex={visibleIndex}
                images={images?.map((i) => i?.uri)}
                withChrono={withChrono}
                time={time}
                style={modalStyle}
            />
        </>
    )
}

export function ImageViewerModal(props) {
    const {
        visible,
        onDismiss,
        imageIndex = 0,
        images,
        withChrono,
        time,
        style,
        headerLeftComponent,
    } = props
    const dimensions = useContext(DimensionsContext)

    return (
        <ModalM
            style={{
                height: IS_WEB ? dimensions?.height : null,
                width: Dimensions.get("window").width,
                flex: 1,
                backgroundColor: "#000",
                borderRadius: 0,
                ...style,
            }}
            visible={visible}
            onDismiss={onDismiss}
        >
            <GestureHandlerRootView style={{ flex: 1 }}>
                <ImageViewer
                    imageIndex={imageIndex}
                    images={images}
                    close={onDismiss}
                    withChrono={withChrono}
                    time={time}
                    headerLeftComponent={headerLeftComponent}
                />
            </GestureHandlerRootView>
        </ModalM>
    )
}

function CameraImagesM(props) {
    const {
        images,
        setImages,
        formId,
        style,
        dismissModal = () => {},
        activityId = null,
        noButton = false,
        longPressDisabled = false,
        imagesDimensions = null,
        onRetry,
        noResend = false,
        scrollToStart = false,
    } = props

    const [isSelecting, setIsSelecting] = useState(false)

    const dimensions = useContext(DimensionsContext)

    useEffect(() => {
        if (
            props.lastPhotoFormId === formId &&
            !!props.lastPhoto &&
            !images?.map((x) => x?.uri)?.includes(props.lastPhoto?.uri)
        ) {
            const imagesCopy = images?.map((x) => x) ?? []
            imagesCopy?.push(props.lastPhoto)
            setImages(imagesCopy)
            props.clearLastPhoto()
        } else if (
            props.lastPhotoFormId === formId &&
            props.lastPhotos?.length > 0
        ) {
            const imagesCopy = images?.map((x) => x) ?? []
            imagesCopy?.push(...props.lastPhotos)
            setImages(imagesCopy)
            props.clearPhotos()
        }
    }, [props.lastPhoto, props.lastPhotos])

    const longPress = (index) => {
        if (isSelecting || longPressDisabled) return
        Vibration.vibrate(50)
        const copy = images?.slice()
        copy[index].selected = true
        setImages(copy)
        dismissModal()
        DialogM.show({
            text1: "Supprimer la photo ?",
            text2: "",
            buttonText1: "Supprimer",
            buttonColor1: theme.colors.error,
            onPress: () => {
                setImages((images) => images.filter((x) => !x.selected))
                if (activityId && images[index]?.id)
                    props.apiRequest(
                        activitiesService.deleteActivityLog,
                        { id: images[index]?.id },
                        {
                            live_mode: !!props.liveSessionId,
                            live_session_id: props.liveSessionId ?? undefined,
                        }
                    )
                resetSelection()
            },
            buttonText2: "Annuler",
            onPressBack: resetSelection,
        })
    }

    const resetSelection = () => {
        setIsSelecting(false)
        setImages((images) => images.map((x) => ({ ...x, selected: false })))
    }

    const height = imagesDimensions
        ? imagesDimensions?.height + 100
        : dimensions?.height * 0.4

    const [launchCamera] = useCamera(formId, true, true)

    const resendComponent = () => {
        return (
            <FilledButtonM
                style={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    width: 120,
                    borderRadius: 30,
                    height: 35,
                }}
                icon={"redo"}
                onPress={onRetry}
                labelStyle={{ fontSize: 8 }}
                color={theme.colors.blackTransparent}
                contentStyle={{ height: 35 }}
                label={"Réessayer"}
            />
        )
    }

    return (
        <ImagesList
            resendComponent={resendComponent}
            noResend={noResend}
            scrollToStart={scrollToStart}
            listFooterComponent={() =>
                !noButton && (
                    <View style={{ height: height }}>
                        <TouchableRipple
                            onPress={() => {
                                launchCamera()
                                dismissModal()
                            }}
                            underlayColor={theme.colors.lighter}
                            disabled={isSelecting}
                            style={{
                                flex: 1,
                                width: images?.length === 0 ? "100%" : 190,
                            }}
                        >
                            <View
                                style={{
                                    flex: 1,
                                    marginHorizontal: 20,
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <FontAwesome5
                                    name={"camera"}
                                    size={32}
                                    color={theme.colors.primary}
                                />
                                <TextM
                                    wrap
                                    fontWeight="ExtraBold"
                                    color={theme.colors.primary}
                                    fontSize={18}
                                    style={{
                                        textAlign: "center",
                                        marginTop: 10,
                                    }}
                                >
                                    {images?.length === 0
                                        ? "Prendre une photo"
                                        : "Ajouter une photo"}
                                </TextM>
                            </View>
                        </TouchableRipple>
                        {props.useGallery && (
                            <TouchableRipple
                                onPress={() => {
                                    pickImage(images, setImages).then()
                                }}
                                underlayColor={theme.colors.lighter}
                                disabled={isSelecting}
                                style={{
                                    flex: 1,
                                    width: images?.length === 0 ? "100%" : 190,
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginHorizontal: 20,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesome5
                                        name="image"
                                        size={32}
                                        color={theme.colors.primary}
                                    />
                                    <TextM
                                        wrap
                                        fontWeight="ExtraBold"
                                        color={theme.colors.primary}
                                        fontSize={18}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                        }}
                                    >
                                        Galerie
                                    </TextM>
                                </View>
                            </TouchableRipple>
                        )}
                    </View>
                )
            }
            photoLongPress={longPress}
            longPressDisabled={longPressDisabled}
            images={images}
            contentHeight={height}
            style={style}
        />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        lastPhoto: state.camera?.lastPhoto,
        lastPhotos: state.camera?.lastPhotos,
        lastPhotoFormId: state.camera?.formId,
        liveSessionId: state.liveMode?.liveSessionId,
        postActivityLogsError: state.api.postActivityLogs?.error,
        audioStatus: state.activity?.audioStatus,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    clearLastPhoto,
    clearPhotos,
}

export default connect(mapStateToProps, mapDispatchToProps)(CameraImagesM)
